export const vehicleOwnerships = [
  'Own',
  'Finance',
  'Lease'
]
